<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import ControlGroupEffects from 'src/components/Controls/Group/ControlGroupEffects.svelte';
	import { is_gen_2 } from 'src/helpers/interface_helpers';

	export let color_mode_lights = [];
</script>

<SidepanelContent>
	<ControlGroupEffects
		color_mode_lights={color_mode_lights.filter(
			(d) => !is_gen_2(d), //filtering gen 2 devices, because plus rgbw doesn't support effects
		)}
	/>
</SidepanelContent>
